<template>
  <MakerCartGuideLayout
    pageTitle="Makercart Anatomy"
    heroImage="/images/maker-cart-guide/frame-1000006404.png"
    previousUrl="/makercart/guide/4"
    nextUrl="/makercart/guide/6"
  >
    <div class="x-guide5-content">
      <div class="x-info-bar">
        <p>Select the features below and view them on the Makercart!</p>
      </div>

      <div class="x-image-container">
        <!-- Center image of Makercart -->
        <img
          :src="images[activeIndex]"
          alt="Makercart Anatomy"
          class="x-cart-image"
        />
      </div>

      <div class="x-tags-container">
        <div
          v-for="(tag, index) in tags"
          :key="index"
          class="x-tag"
          :class="{ 'x-tag-active': activeIndex === index }"
          @click="activeIndex = index"
        >
          {{ tag }}
        </div>
      </div>
    </div>
  </MakerCartGuideLayout>
</template>

<script setup>
import { ref } from "vue";
import MakerCartGuideLayout from "@/components/maker-cart/MakerCartGuideLayout.vue";

const activeIndex = ref(0);

const images = [
  "/images/maker-cart-guide/img-2.png",
  "/images/maker-cart-guide/img-3.png",
  "/images/maker-cart-guide/img-4.png",
  "/images/maker-cart-guide/img-5.png",
];

const tags = [
  "Hooks for Easy Access. Utilize Magnetic Pegboards.",
  "Organized Item Boxes and Bins.",
  "Activity-Specific Boxes.",
  "Easy Mobility. Wheel Stopper.",
];
</script>

<style scoped>
.x-guide5-content {
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
}

.x-image-container {
  display: flex;
  height: 500px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.x-cart-image {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.x-tags-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.x-tag {
  display: flex;
  align-items: center;
  padding: 8px 16px;
  border-radius: 16px;
  border: 1px solid #d8dae5;
  font-family: "League Spartan", sans-serif;
  font-weight: 500;
  font-size: var(--fs-medium);
  line-height: 24px;
  color: #3b4648;
  letter-spacing: 0.024px;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.x-tag:hover {
  background-color: #f5f6fa;
}

.x-tag-active {
  background-color: #e6ecf0;
  border-color: var(--primary-blue);
}

.x-tag-active:hover {
  background-color: #e6ecf0;
}

.x-info-bar {
  display: flex;
  background-color: var(--green-dark-1);
  color: #ffffff;
  padding: 16px;
  align-items: center;
  justify-content: flex-start;
  margin-top: 16px;
  display: none;
}

.x-info-bar p {
  margin: 0;
  font-family: "League Spartan", sans-serif;
  font-size: var(--fs-small);
  line-height: 20px;
  letter-spacing: 0.014px;
}

@media (max-width: 768px) {
  .x-guide5-content {
    gap: 16px;
  }

  .x-info-bar {
    display: flex;
    margin: 0 -16px 0 -16px; /* offset the layout gap/padding */
    padding: 16px 16px;
  }

  .x-image-container {
    height: 360px;
    margin: 0 auto;
  }

  .x-tags-container {
    gap: 8px;
    padding: 0;
    padding-bottom: 24px;
    justify-content: start;
  }
}
</style>
